<app-menu [hasChanges]="loadMenu" title="Asignación de vendedores"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="p-fluid pl-2 flex flex-wrap align-items-center">
    <div class="w-full md:w-6 pr-3">
        <div class="w-full">
            <label>Digite nro. de venta</label>
            <p-inputNumber class="w-full" placeholder="Digite nro. de venta" [(ngModel)]="idVenta" size="small"
                [autofocus]="true">
            </p-inputNumber>
        </div>
    </div>
    <!-- Selección de vendedor -->
    <div class="w-full md:w-6">
        <label>Selección de Vendedor</label>
        <p-select optionLabel="label" [(ngModel)]="selectedSales" optionValue="id" [options]="vendedor" size="small"
            [virtualScroll]="true" placeholder="Seleccione el vendedor"></p-select>
    </div>
    <div class="w-full pt-2">
        <div class="w-max mx-auto">
            <button #btnProcesar pButton icon="pi pi-check-circle" label="Asignar vendedor a venta"
                class="p-button p-button-success" (click)="procesar()"></button>
        </div>
    </div>

</div>
<p-toast></p-toast>